export default __webpack_public_path__ + "static/test4-e5a3b73ab031cbe2fc1eefecf1547323.jpeg";